<template lang="html">
<Cell is-link>
    <!-- 使用 title 插槽来自定义标题 -->
    <div slot="title">
        <span class="custom-title size-28">已选</span>
    </div>
    <div slot="default" class="goods-spec ">
        <span class="size-24 col-fcGreyish">{{ detail.goods.goods_spec | spaceFilter}}
            {{selectedSku.num}} {{detail.goods.goods_unit}}</span>
    </div>
</Cell>
</template>

<script>
import {
    Cell
} from 'vant'
export default {
    name: 'deliveryGoodsBox',
    props: {
        detail : {
            type: Object,
            default () {
                return {}
            }
        },
        selectedSku: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    filters: {
        spaceFilter (value) {
            return (value && value.join()) || ''
        }
    },
    components: {
        Cell
    },
    created () {
    }
}
</script>

<style  lang="stylus" scoped >
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.goods-box
    background white
.goods-spec
    textOverflow()

</style>
